import { render, staticRenderFns } from "./CompAudioPlayerWithSubtitles.vue?vue&type=template&id=492eefda&scoped=true&"
import script from "./CompAudioPlayerWithSubtitles.vue?vue&type=script&lang=ts&"
export * from "./CompAudioPlayerWithSubtitles.vue?vue&type=script&lang=ts&"
import style0 from "./CompAudioPlayerWithSubtitles.vue?vue&type=style&index=0&id=492eefda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492eefda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VFileInput,VIcon,VRow,VSelect,VSheet,VTooltip})
